import { useRouteEntities } from 'contexts/RouteEntityContext';
import { BreadcrumbSeparator, BreadcrumbText } from 'pages/Settings/FileLibrary/styled';
import React from 'react';

import { PathToIdMapping } from './hooks/useFolderIdsInPath';
import { createFileLibraryDirentNavPath, toRequiredScope } from './path';

export type FileBreadcrumbProps = Readonly<{
    paths: PathToIdMapping[];
    resetPaging: () => void;
}>;

export function FileBreadcrumb({ paths, resetPaging }: FileBreadcrumbProps) {
    const { corporation, location } = useRouteEntities();

    const scope = toRequiredScope(corporation?.Id, location?.Id);

    return (
        <div className="p-2">
            <BreadcrumbText
                to={createFileLibraryDirentNavPath(
                    { ...scope, id: undefined, path: '/' },
                    'folder',
                )}
                onClick={() => {
                    resetPaging();
                }}
            >
                File Library
            </BreadcrumbText>

            {paths.map((folder, index, array) => {
                const isLastFolder = index === array.length - 1;
                return (
                    <React.Fragment key={folder.id}>
                        <BreadcrumbText
                            to={createFileLibraryDirentNavPath(
                                { ...scope, ...folder },
                                'folder',
                            )}
                        >
                            {folder.name}
                        </BreadcrumbText>
                        {!isLastFolder && (
                            <BreadcrumbSeparator className="mx-5">/</BreadcrumbSeparator>
                        )}
                    </React.Fragment>
                );
            })}

            <BreadcrumbSeparator className="mx-5">/</BreadcrumbSeparator>
        </div>
    );
}
